(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["compare-button"] && !Shopify.designMode) return;
  try {
    class CompareButton {
    constructor() {
      this.buttons = document.querySelectorAll('[data-compare-btn]');
      this.storageKey = 'vektools-compare';
      this.maxItems = 4;
      this.init();
    }

    init() {
      this.loadCompare();
      this.buttons.forEach(btn => {
        btn.addEventListener('click', (e) => this.toggleCompare(e));
      });
    }

    loadCompare() {
      const compare = this.getCompare();
      compare.forEach(productId => {
        const btn = document.querySelector(`[data-compare-btn="${productId}"]`);
        if (btn) this.updateButtonState(btn, true);
      });
      this.updateDisabledState();
    }

    toggleCompare(e) {
      const btn = e.currentTarget;
      const productId = btn.getAttribute('data-compare-btn');
      const compare = this.getCompare();
      const index = compare.indexOf(productId);

      if (index > -1) {
        compare.splice(index, 1);
        this.updateButtonState(btn, false);
      } else {
        if (compare.length < this.maxItems) {
          compare.push(productId);
          this.updateButtonState(btn, true);
        } else {
          alert(`You can only compare up to ${this.maxItems} products`);
          return;
        }
      }

      this.saveCompare(compare);
      this.updateDisabledState();
    }

    updateButtonState(btn, isAdded) {
      if (isAdded) {
        btn.classList.add('added');
      } else {
        btn.classList.remove('added');
      }
    }

    updateDisabledState() {
      const compare = this.getCompare();
      this.buttons.forEach(btn => {
        const productId = btn.getAttribute('data-compare-btn');
        if (compare.length >= this.maxItems && !compare.includes(productId)) {
          btn.disabled = true;
        } else {
          btn.disabled = false;
        }
      });
    }

    getCompare() {
      const data = localStorage.getItem(this.storageKey);
      return data ? JSON.parse(data) : [];
    }

    saveCompare(compare) {
      localStorage.setItem(this.storageKey, JSON.stringify(compare));
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    new CompareButton();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    /* ── Portal quick-view modals to <body> ─────────────────────
       Quick-view modals are rendered inside .product-card__media
       which has overflow:hidden. Although position:fixed should
       escape that, a CSS transform on the card creates a new
       stacking context that traps fixed descendants.
       Moving the modals to <body> avoids this entirely.
    ─────────────────────────────────────────────────────────── */
    function portalModals() {
      document.querySelectorAll('.quick-view-modal').forEach(function (modal) {
        if (modal.parentElement !== document.body) {
          document.body.appendChild(modal);
        }
      });
    }

    /* ── Toast helper ────────────────────────────────────────── */
    var toastEl = null;
    var toastTimer = null;

    function showToast(msg) {
      if (!toastEl) {
        toastEl = document.createElement('div');
        toastEl.className = 'pc-toast';
        toastEl.setAttribute('role', 'status');
        toastEl.setAttribute('aria-live', 'polite');
        document.body.appendChild(toastEl);
      }
      toastEl.textContent = msg;
      toastEl.classList.add('pc-toast--visible');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toastEl.classList.remove('pc-toast--visible');
      }, 2800);
    }

    /* ── Patch compare buttons to use toast ─────────────────── */
    function patchCompareAlerts() {
      document.querySelectorAll('[data-compare-btn]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          /* Only intercept when the list is already at max.
             CompareButton.toggleCompare() fires first due to propagation;
             we catch the result via the disabled state it sets. */
          var storageKey = 'vektools-compare';
          var data = localStorage.getItem(storageKey);
          var compare = data ? JSON.parse(data) : [];
          var productId = btn.getAttribute('data-compare-btn');

          if (compare.length >= 4 && !compare.includes(productId)) {
            e.stopImmediatePropagation();
            showToast('You can compare up to 4 products at a time.');
          }
        }, true); /* capture phase — runs before the original listener */
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        portalModals();
        patchCompareAlerts();
      });
    } else {
      portalModals();
      patchCompareAlerts();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-view"] && !Shopify.designMode) return;
  try {
    class QuickView {
    constructor() {
      this.triggers = document.querySelectorAll('[data-quick-view-trigger]');
      this.modals = document.querySelectorAll('[data-quick-view-modal]');
      this.init();
    }

    init() {
      this.triggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => this.openModal(e));
      });

      this.modals.forEach(modal => {
        const closeButtons = modal.querySelectorAll('[data-quick-view-close]');
        closeButtons.forEach(btn => {
          btn.addEventListener('click', (e) => this.closeModal(e));
        });

        modal.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') this.closeModal(e);
        });
      });
    }

    openModal(e) {
      e.preventDefault();
      const productId = e.currentTarget.getAttribute('data-quick-view-trigger');
      const modal = document.querySelector(`[data-quick-view-modal][data-product-id="${productId}"]`);
      if (modal) {
        modal.classList.add('open');
        document.body.style.overflow = 'hidden';
      }
    }

    closeModal(e) {
      const modal = e.currentTarget.closest('[data-quick-view-modal]');
      if (modal) {
        modal.classList.remove('open');
        document.body.style.overflow = '';
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    new QuickView();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-button"] && !Shopify.designMode) return;
  try {
    class WishlistButton {
    constructor() {
      this.buttons = document.querySelectorAll('[data-wishlist-btn]');
      this.storageKey = 'vektools-wishlist';
      this.init();
    }

    init() {
      this.loadWishlist();
      this.buttons.forEach(btn => {
        btn.addEventListener('click', (e) => this.toggleWishlist(e));
      });
    }

    loadWishlist() {
      const wishlist = this.getWishlist();
      wishlist.forEach(productId => {
        const btn = document.querySelector(`[data-wishlist-btn="${productId}"]`);
        if (btn) this.updateButtonState(btn, true);
      });
    }

    toggleWishlist(e) {
      const btn = e.currentTarget;
      const productId = btn.getAttribute('data-wishlist-btn');
      const wishlist = this.getWishlist();
      const index = wishlist.indexOf(productId);

      if (index > -1) {
        wishlist.splice(index, 1);
        this.updateButtonState(btn, false);
      } else {
        wishlist.push(productId);
        this.updateButtonState(btn, true);
      }

      this.saveWishlist(wishlist);
    }

    updateButtonState(btn, isAdded) {
      const emptyIcon = btn.querySelector('.wishlist-btn__icon-empty');
      const filledIcon = btn.querySelector('.wishlist-btn__icon-filled');

      if (isAdded) {
        btn.classList.add('added');
        emptyIcon.style.display = 'none';
        filledIcon.style.display = 'block';
      } else {
        btn.classList.remove('added');
        emptyIcon.style.display = 'block';
        filledIcon.style.display = 'none';
      }
    }

    getWishlist() {
      const data = localStorage.getItem(this.storageKey);
      return data ? JSON.parse(data) : [];
    }

    saveWishlist(wishlist) {
      localStorage.setItem(this.storageKey, JSON.stringify(wishlist));
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    new WishlistButton();
  });
  } catch(e) { console.error(e); }
})();

})();
